module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_j_normal.99c02e8f.png";